import React from "react";
import axios from "../../containers/api";
import { showCatchError } from "../../helpers/Utils";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Badge,
} from "reactstrap";
import { Table } from "../../components/table/Table"; // کامپوننت اصلی
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import NewComment from "./NewComment";

class ManageComment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CommentLists: [],
      AddModal: false,
    };
  }

  componentDidMount() {
    this.GetAllComment();
  }

  GetAllComment = () => {
    this.props.showSpinner();
    axios
      .get("api/v1/comments/GetAllUserComment")
      .then((res) => {
        this.props.hideSpinner();
        if (res.data.data) {
          this.setState({ CommentLists: res.data.data });
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  openModal = (modalName) => {
    this.setState({ [modalName]: true });
  };

  closeModal = (modalName) => {
    this.setState({ [modalName]: false });
    this.GetAllComment();
  };

  render() {
    const { CommentLists, AddModal } = this.state;

    return (
      <>
        {/* استایل‌های داخلی */}
        <style jsx>{`
          .page-container {
            direction: rtl;
            padding: 20px;
            background: #f8f9fa;
            min-height: 100vh;
          }
          .page-header {
            background: linear-gradient(135deg, #d5711f, #d5711f);
            color: white;
            padding: 1.8rem 2rem;
            border-radius: 16px;
            box-shadow: 0 8px 25px rgba(67, 97, 238, 0.25);
            margin-bottom: 2rem;
            text-align: center;
          }
          .page-title {
            font-size: 1.6rem;
            font-weight: 700;
            margin: 0;
          }
          .card-main {
            border: none;
            border-radius: 18px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
          }
          .card-main:hover {
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
            transform: translateY(-3px);
          }
          .btn-add {
            background: linear-gradient(135deg, #2ecc71, #27ae60);
            border: none;
            border-radius: 14px;
            padding: 12px 28px;
            font-weight: 600;
            color: white;
            box-shadow: 0 6px 16px rgba(46, 204, 113, 0.3);
            transition: all 0.3s ease;
          }
          .btn-add:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 25px rgba(46, 204, 113, 0.4);
          }

          /* استایل‌دهی به کامپوننت Table */
          :global(.custom-table-wrapper) {
            margin-top: 1.5rem;
            overflow-x: auto;
            border-radius: 14px;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
          }
          :global(.custom-table-wrapper table) {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0 10px;
            margin: 0;
          }
          :global(.custom-table-wrapper th) {
            background: #f1f3f5 !important;
            color: #2d3436 !important;
            font-weight: 700 !important;
            font-size: 0.95rem !important;
            padding: 16px 20px !important;
            text-align: center !important;
            border: none !important;
            position: sticky;
            top: 0;
            z-index: 10;
          }
          :global(.custom-table-wrapper td) {
            background: white !important;
            padding: 18px 20px !important;
            text-align: center !important;
            border: none !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
            transition: all 0.2s ease;
          }
          :global(.custom-table-wrapper tr:hover td) {
            background: #f8f9fa !important;
            transform: scale(1.01);
          }
          :global(.ellipsis-cell) {
            max-width: 280px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: help;
          }
          :global(.ellipsis-cell:hover) {
            white-space: normal;
            overflow: visible;
            word-break: break-word;
            background: #fff;
            z-index: 100;
            position: relative;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            padding: 12px;
          }

          .badge-custom {
            font-size: 0.8rem;
            padding: 6px 12px;
            border-radius: 20px;
            font-weight: 600;
          }

          .modal-custom .modal-content {
            border-radius: 18px;
            border: none;
            box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
          }
          .modal-custom .modal-header {
            background: linear-gradient(135deg, #d5711f, #d5711f);
            color: white;
            border-radius: 18px 18px 0 0;
            padding: 1.5rem;
          }
          .modal-custom .modal-title {
            font-weight: 700;
            font-size: 1.3rem;
          }

          @media (max-width: 768px) {
            .page-header {
              padding: 1.2rem;
              font-size: 1.3rem;
            }
            .btn-add {
              padding: 10px 20px;
              font-size: 0.9rem;
            }
            :global(.custom-table-wrapper th),
            :global(.custom-table-wrapper td) {
              padding: 12px 10px !important;
              font-size: 0.9rem !important;
            }
          }
        `}</style>

        <div className="page-container">
          {/* هدر صفحه */}
          <div className="page-header">
            <h1 className="page-title">مدیریت پیام‌ها</h1>
            <p
              style={{ margin: "8px 0 0", fontSize: "1rem", opacity: 0.9 }}
            ></p>
          </div>

          <Row>
            <Colxx xxs="12">
              <Card className="card-main">
                <CardBody className="p-4">
                  {/* دکمه افزودن */}
                  <div className="d-flex justify-content-center mb-4">
                    <Button
                      className="btn-add"
                      onClick={() => this.openModal("AddModal")}
                    >
                      افزودن پیام جدید
                    </Button>
                  </div>

                  {/* جدول با کامپوننت اصلی Table */}
                  <div className="custom-table-wrapper">
                    <Table
                      tableHeaders={[
                        "عنوان",
                        "متن پیام",
                        "تاریخ پیام",
                        "ساعت پیام",
                      ]}
                      tableRow={CommentLists}
                      tableData={[
                        (item) => <strong>{item.title}</strong>,
                        (item) => (
                          <div className="ellipsis-cell" title={item.desc}>
                            {item.desc}
                          </div>
                        ),
                        (item) => (
                          <Badge color="info" className="badge-custom">
                            {item.date}
                          </Badge>
                        ),
                        (item) => (
                          <Badge color="secondary" className="badge-custom">
                            {item.time}
                          </Badge>
                        ),
                      ]}
                      emptyMessage="پیامی یافت نشد"
                    />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
          </Row>

          {/* مودال افزودن پیام */}
          <Modal
            isOpen={AddModal}
            size="lg"
            toggle={() => this.closeModal("AddModal")}
            className="modal-custom"
            backdrop="static"
          >
            <ModalHeader toggle={() => this.closeModal("AddModal")}>
              افزودن پیام جدید
            </ModalHeader>
            <ModalBody>
              <NewComment
                isModal={true}
                showSpinner={this.props.showSpinner}
                hideSpinner={this.props.hideSpinner}
                showSweetAlert={this.props.showSweetAlert}
                closeSweetAlert={this.props.closeSweetAlert}
                showAlert={this.props.showAlert}
                onSuccess={() => this.closeModal("AddModal")}
              />
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
}

export default ManageComment;
